export default __webpack_public_path__ + "static/media/2.3a445b45.png";